import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import React, { useEffect, useState } from 'react'

import { publicCall } from '../utils'

const PublicCallSwitchGuard = () => {
  const [switched, setSwitched] = useState(false)

  useEffect(() => publicCall.onSwitch(() => setSwitched(true)), [])

  const goHome = () => window.location.assign('/')

  return (
    <Dialog
      open={switched}
      disableEscapeKeyDown
      aria-labelledby="public-call-switch-title"
    >
      <DialogTitle id="public-call-switch-title">
        Você trocou de chamada em outra aba
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          O portal trabalha com uma chamada por vez. O que estava aberto nesta
          aba era da chamada anterior e não foi enviado. Vamos voltar ao início,
          já na chamada escolhida.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={goHome}>
          Voltar ao início
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PublicCallSwitchGuard
